import { render, staticRenderFns } from "./ComprasCadastraProduto.vue?vue&type=template&id=1671312a"
import script from "./ComprasCadastraProduto.vue?vue&type=script&lang=js"
export * from "./ComprasCadastraProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports